export default __webpack_public_path__ + "static/media/rename-icon.e7b97bb8.png";